import { render, staticRenderFns } from "./TravelList.vue?vue&type=template&id=d0a38a2a&scoped=true&"
import script from "./TravelList.vue?vue&type=script&lang=js&"
export * from "./TravelList.vue?vue&type=script&lang=js&"
import style0 from "./TravelList.vue?vue&type=style&index=0&id=d0a38a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a38a2a",
  null
  
)

export default component.exports